


























































// 3rd party libs
import {
    mapGetters,
} from 'vuex';

// Components
import chips from '@webapp/components/chips.vue';

export default {
    name: 'chips-carousel',
    components: {
        chips,
    },
    props: {
        items: {
            type: Array,
            default: () => ([]),
        },
        isSelected: {
            type: Function,
            required: true,
        },
        isAllSelected: {
            type: Boolean,
            required: true,
        },
        selectedMaxChips: {
            type: Number,
            default: 0,
            required: false,
        },
        isAllDisabled: {
            type: Boolean,
            default: false,
            required: false,
        },
    },
    computed: {
        ...mapGetters(['getTranslatedStr']),
        selectedItems() {
            return this.items.length ? this.items.filter((item) => this.isSelected(item.id)) : [];
        },
    },
    methods: {
        selectChip(item) {
            this.$emit('filtersChanged', item.id);
        },
        chipStatusClasses(item) {
            return {
                'chips-carousel__filter-chips--selected':
                this.isSelected(item.id) && !this.isAllSelected,
                'chips-carousel__filter-chips--selected-max-chips':
                this.selectedMaxChips > 0 && !this.isAllSelected &&
                this.selectedItems.length >= this.selectedMaxChips &&
                !this.isSelected(item.id),
            };
        },
    },
};
